import { useAsyncState } from '@/infranstructure/useAsyncState'
import { usePathFromBaseURI, useQuery } from '@/api/configuration/endpoints'
import { Request } from '@/api/Request'
import { PostRequest } from '@/api/PostRequest'
import { ConfirmationPhoneResponse, VerifyPhoneLikeCodeResponse } from './types'
import { phoneLikeIdentities } from '@/models/digitalIdentities'

export interface GeneratePayload {
  type: typeof phoneLikeIdentities[number]
  data: string
}

export interface VerifyPayload {
  data: string
  code: string
}

/**
 * Команда генерации кода для "phonelike" идентификаторов через DigitalIdentityConfirmation.
 */
export const useGenerateCodeCommand = (
  apiKey: string,
  onError: (ex: unknown) => void
) =>
  useAsyncState<ConfirmationPhoneResponse, [GeneratePayload]>(
    async (payload) => {
      const endpointUri = useQuery(
        () => usePathFromBaseURI('avissign', 'DigitalIdentityConfirmation', 'GenerateCode'),
        { name: 'key', value: apiKey }
      )
      const query = new PostRequest(
        new Request<ConfirmationPhoneResponse>(endpointUri.href),
        payload
      )
      const response = await query.response()
      return response.data
    },
    { data: '' },
    {
      immediate: false,
      onError(ex: unknown) {
        console.warn(ex)
        onError(ex)
      },
    }
  )

/**
 * Команда проверки кода для "phonelike" идентификаторов через DigitalIdentityConfirmation.
 */
export const useSendCodeCommand = (
  apiKey: string,
  onError: (ex: unknown) => void
) =>
  useAsyncState<VerifyPhoneLikeCodeResponse, [VerifyPayload]>(
    async (payload) => {
      const endpointUri = useQuery(
        () => usePathFromBaseURI('avissign', 'DigitalIdentityConfirmation', 'VerifyCode'),
        { name: 'key', value: apiKey }
      )
      const query = new PostRequest(
        new Request<VerifyPhoneLikeCodeResponse>(endpointUri.href),
        payload
      )
      const response = await query.response()
      return response.data
    },
    { isValid: false },
    {
      immediate: false,
      onError(ex: unknown) {
        console.warn(ex)
        onError(ex)
      },
    }
  )
